<template>
<!-- 面包屑 -->
    <div class="breadcrumbs">
        <el-breadcrumb class="breadcrumbs_title" separator-class="el-icon-arrow-right">
            <el-breadcrumb-item v-for="item in dataList" :key="item">{{item}}</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>
<script>
export default {
    data(){
        return{
            dataList:[]
        }
    },
    props:['arr'],
    methods:{
        init(){
            if(this.arr)
                this.$set(this,'dataList',this.arr)
        }
    },
    mounted(){
        this.init()
    },
    arr:{
        handler(val){
            this.$set(this,'dataList',val)
        },
        immediate:true
    },
}
</script>
<style scoped>
    ::v-deep .breadcrumbs_title{
        height: 50px;
        line-height: 50px;
    }
</style>